<template>
  <section>
    <div class="container content-padding" v-if="!needVerifyOtp">
      <div class="row text-center">
        <div class="col-12">
          <img src="/static/img/logo.png" alt="logo" class="img-fluid" style="height: 85px;">
        </div>
      </div>
      <div class="row justify-content-md-center mt-5">
        <div class="col-md-6 text-center">
          <div class="form-group">
            <input type="text"
                   class="form-control input-lg"
                   placeholder="Username" required
                   v-model="username">
          </div>
          <div class="form-group">
            <input type="password"
                   maxlength="20"
                   class="form-control input-lg"
                   placeholder="Password" required
                   v-model="password">
          </div>
          <div class="form-group">
            <button class="btn btn-info btn-block"
                    @click="login()"
                    :disabled="isLoading">
              {{ loginTextButton }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- ถ้ามีการขอ OTP จะแสดงผล input ให้กรอก OTP ก่อนเข้าสู่ระบบ -->
      <sendPartnerOTP :username="username"
                      :password="password"
                      :emailSentOtp="emailSentOtp"
                      @clearData="clearData"
      ></sendPartnerOTP>
    </div>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import SendPartnerOTP from './SendPartnerOTP'

  export default {
    name: 'Login',
    components: {
      sendPartnerOTP: SendPartnerOTP
    },
    data () {
      return {
        username: '',
        password: '',
        isLoading: false,
        needVerifyOtp: false,
        emailSentOtp: ''
      }
    },
    computed: {
      loginTextButton () {
        return this.isLoading ? 'LOGIN...' : 'LOGIN'
      }
    },
    methods: {
      ...mapActions('authPartner', {
        LOGIN_PARTNER: 'LOGIN',
        GET_PARTNER: 'GET_PARTNER'
      }),

      async login () {
        this.isLoading = true
        try {
          const dataPartnerLogin = await this.LOGIN_PARTNER({ username: this.username, password: this.password })
          // ถ้า partner นี้ต้องการ otp จะเช็ค otp ก่อน
          if (dataPartnerLogin.need_otp) {
            this.needVerifyOtp = true
            this.emailSentOtp = dataPartnerLogin.email
            return
          }
          // Another Partner
          const dataPartner = await this.GET_PARTNER(dataPartnerLogin)
          this.$router.push({ path: `/partners/${dataPartner.id}/report`, replace: true })
        } catch (err) {
          console.log(err)
          this.$swal({ title: 'ไม่สามารถเข้าสู่ระบบได้', text: 'อีเมล หรือ รหัสผ่านไม่ถูกต้อง', type: 'error' })
        }
        this.isLoading = false
      },
      clearData () {
        this.username = ''
        this.password = ''
        this.isLoading = false
        this.needVerifyOtp = false
      }
    },
    created () {
      this.clearData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partner/Login.vue